<app-page-header
  title="Kundenaccounts verwalten"
  subtitle="Suche und verwalte alle Kundenaccounts"
  icon="people"
  variant="gradient">
</app-page-header>

<!-- Search Field (optional, if you have filtering) -->
<!--
<div class="apple-container apple-slide-up">
  <div class="apple-search-card apple-card">
    <mat-form-field appearance="outline" class="apple-search-field">
      <mat-label>Suche nach Kunde</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Kundennr, Name, E-Mail..." />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>
-->

<div class="apple-container">
  <div class="apple-manage-customers-table-card apple-card">
    <table class="apple-manage-customers-table">
      <thead>
        <tr class="apple-table-header-row">
          <th class="global-table-header-cell">Kundennr.</th>
          <th class="global-table-header-cell">Name</th>
          <th class="global-table-header-cell">E-Mail</th>
          <th class="global-table-header-cell">Aktionen</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let customer of customers$ | async" class="apple-table-row">
          <td class="global-table-cell">{{ customer?.reflexCustomerNo }}</td>
          <td class="global-table-cell">{{ customer?.userDetails?.firstName }} {{ customer?.userDetails?.lastName }}</td>
          <td class="global-table-cell">{{ customer?.userDetails?.email }}</td>
          <td>
            <div class="customer-actions-btn-row">
              <button mat-flat-button color="accent" class="apple-details-btn" (click)="toggleActivation(customer)">
                <span>{{ customer.isActive ? 'Deaktivieren' : 'Aktivieren' }}</span>
                <mat-icon>{{ customer.isActive ? 'block' : 'check_circle' }}</mat-icon>
              </button>
              <button mat-flat-button color="primary" class="apple-details-btn" (click)="goToCustomer(customer)">
                <span>Details</span>
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="(customers$ | async)?.length === 0" class="empty-state">
      Keine Kunden gefunden.
    </div>
  </div>
</div>
